import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import govseal from "../componets/govseal.jpg"

function Footer() {
  return (
    <div className='footer-container'>





        <div className='footer-links'>
            <div className='footer-wrapper'>
               <img className='govseal' src={govseal} alt="logo" />


                <div className='footer-links-items'>
                    <h2>REPUBLIC OF THE PHILIPPINES</h2>
                    <p>All content is in the public domain unless otherwise stated.</p>

                </div>
                <div className='footer-links-items'>
                    <h2>ABOUT GOVPH</h2>
                    <p>Learn more about the Philippine government, its structure, how government works and the people behind it.</p>
                    <br></br>
                    <Link to = {{ pathname: 'https://www.gov.ph/'}} target= {"_blank"} >GOV.PH</Link>
                    <Link to='/'>Open Data Portal</Link>
                    <Link to='/'>Official Gazette</Link>
                </div>
                <div className='footer-links-items'>
                    <h2>GOVERMENT LINKS</h2>
                    <Link to='/'>Office of the President</Link>
                    <Link to='/'>Office of the Vice President</Link>
                    <Link to='/'>Senate of the Philippines</Link>
                    <Link to='/'>House of Representatives</Link>
                    <Link to='/'>Supreme Court</Link>
                    <Link to='/'>Court of Appeals</Link>
                    <Link to='/'>Sandiganbayan</Link>
                </div>
                </div>


        </div>
    </div>
  )
}

export default Footer;